// The reducer
import { createSlice } from '@reduxjs/toolkit';

export const routeInitialState = {
  hasParam: false,
};

// Then, handle actions in your reducers:
const routeSlice = createSlice({
  name: 'route',
  routeInitialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    routeSetHasParamState: (state, { payload }) => {
      state.hasParam = payload;
    },
  },
});

// actions generated from the slice, TODO: remove start,success,fail
export const { routeSetHasParamState } = routeSlice.actions;

// The reducer
export const routeReducer = routeSlice.reducer;
